module.exports = __webpack_public_path__ + "img/global-not_message.png?1ae3bb01";